import { ReactElement } from 'react'
import { EActionId, IMessage } from '@/features/messages/shared/types'
import { Link } from 'react-router-dom'

export default function ActionCell({ actionId, documentLink }: IMessage): ReactElement {
  return (
    <Link to={`/documents/${documentLink}`} className="c-messages-table__action-cell">{EActionId[actionId]}</Link>
  )
}
